import { MiniGameAddOnResult } from '@Config/draw-results-types'
import { TicketInfo } from '@Config/ticket-form-types'
import _ from 'lodash'
import { ListResult } from '../list-view/list-view'
import { NumberSelectionSummary } from '../number-selection-summary/number-selection-summary'
import {
  MatchStatus,
  NUMBER_SELECTION_SUMMARY,
} from '../number-selection-summary/number-selection-summary-types'
import { Fragment, useCallback } from 'react'
import { Utils } from '@Util/utils'

export type ReceiptBreakdownMiniGameSummaryProps = {
  className: string
  kenoResult: ListResult
  ticketInfo: TicketInfo
}

export const ReceiptBreakdownMiniGameSummary = ({
  className,
  kenoResult,
  ticketInfo,
}: ReceiptBreakdownMiniGameSummaryProps) => {
  const getResultsForMiniGame = useCallback(
    (miniGameAddonName: string) => {
      return kenoResult.miniGameAddOnResult?.name === miniGameAddonName
        ? kenoResult.miniGameAddOnResult
        : null
    },
    [kenoResult],
  )

  if (!kenoResult.scoringBreakdown?.miniGameAddonWinnings.length) {
    return null
  }

  return (
    <>
      <hr />
      {kenoResult.scoringBreakdown?.miniGameAddonWinnings.map((mgaw) => {
        const results = getResultsForMiniGame(mgaw.addonName)

        const ticketSelection = ticketInfo.miniGameAddOnSelection

        if (!ticketSelection) return null

        const matchingNumbers = _.intersection(
          (results as MiniGameAddOnResult)?.results,
          ticketSelection.numberSelections,
        )

        const numberSelections = [...ticketSelection.numberSelections]
          .sort((a, b) => a - b)
          .map((n) => {
            return {
              number: n,
              matchStatus: matchingNumbers.includes(n) ? MatchStatus.MATCH : MatchStatus.UNMATCHED,
              addOnName: null,
            }
          })

        return (
          <Fragment key={mgaw.addonName}>
            <div className={`${className}__receipt-breakdown__section`}>
              <div className={`${className}__receipt-breakdown__section__column`}>
                {mgaw.addonName}
              </div>
              <div className={`${className}__receipt-breakdown__section__column`}>
                <div className={`${className}__receipt-breakdown__section__column__center`}>
                  Match {mgaw.numberMatched} of {ticketSelection.numberSelections.length}
                </div>
                <div>{Utils.convertCentsNumberToDollarString(mgaw.winningsInCents)}</div>
              </div>
            </div>
            <NumberSelectionSummary
              addOnDetails={[]}
              numbersPerRow={ticketSelection.numberSelections.length}
              numberSelections={numberSelections}
              className={`${className}__receipt-breakdown__mini-game-selections`}
              type={NUMBER_SELECTION_SUMMARY.MINI_GAME}
            />
          </Fragment>
        )
      })}
    </>
  )
}
